import theme from '../../themes/index.en'; 
import { rgba } from 'polished'; 

const { palette, spacing, typography } = theme;

const RegisterStyles = {
  boxStyle: { 
    padding: spacing(2),
    border: `1px solid ${palette.text.disabled}`,
    borderRadius: 2,  
  },
  mainSection: { 
    backgroundColor: theme.palette.background.paper,
    '& .MuiFormControl-root': {
        backgroundColor: palette.background.paper, 
        padding: 0, 
      },
    '& .MuiOutlinedInput-root': {
        backgroundColor: palette.background.default,  
      },
  },
  boxColoredStyle: { 
    padding: spacing(2),
    border: `1px solid ${palette.text.disabled}`,
    backgroundColor: palette.text.disabled,
    borderRadius: 2,  
  },
  paragraphStyle: { 
    fontSize: "0.9rem", 
    width: "75%", 
    wordWrap: "break-word",
  },
};

export default RegisterStyles;
